import { isLocalDev } from "./env.ts";

export const getCountry = (): Promise<string> => {
  if (window.CookieCat?.info) {
    return new Promise((resolve) => {
      window.CookieCat.info((resp) => resolve(resp.geo.country));
    });
  } else if (isLocalDev()) {
    return Promise.resolve("US");
  } else {
    return Promise.resolve("");
  }
};
